import React from "react";
import ActionHeaderFileNameSection from "./HeaderFileName";
import ActionHeaderCenterControls from "./Zoom";
import PreviewHeaderActions from "./PreviewHeaderActions";
import type { AttachmentPreviewActionHeaderProps } from "app/containers/Features/containers/Ticket/types";

const AttachmentPreviewActionHeader: React.FC<
  AttachmentPreviewActionHeaderProps
> = ({
  fileName,
  onDownload,
  onOpenFile,
  onCopyUrl,
  onDelete,
  onClose,
  onRenameSubmit,
  zoomLevel = 100,
  onZoomOut,
  onZoomIn,
  currentItemNumber = 1,
  totalItems = 1,
}) => {
  return (
    <div className="bg-[#262626] flex items-center h-[56px] px-6 py-4">
      <ActionHeaderFileNameSection
        fileName={fileName}
        onRenameSubmit={onRenameSubmit}
      />
      <ActionHeaderCenterControls
        currentItemNumber={currentItemNumber}
        totalItems={totalItems}
        zoomLevel={zoomLevel}
        onZoomOut={onZoomOut}
        onZoomIn={onZoomIn}
      />
      <PreviewHeaderActions
        onDownload={onDownload}
        onOpenFile={onOpenFile}
        onCopyUrl={onCopyUrl}
        onDelete={onDelete}
        onClose={onClose}
      />
    </div>
  );
};

export default AttachmentPreviewActionHeader;

